module.exports = __webpack_public_path__ + "media/images/icon-book-1cbbcdd12b0e9907578f87c4107f9edd.svg";